<app-generate-invoice
 [isClientGenerateInvoice]="true"
 [petitionerId]="petitionerId">

</app-generate-invoice>